"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
var html = (_a = document.getElementById("html")) === null || _a === void 0 ? void 0 : _a.getAttribute('lang');
i18next_1.default
    .use(react_i18next_1.initReactI18next)
    .use(i18next_http_backend_1.default)
    .init({
    fallbackLng: (html) ? html : 'ru',
    debug: false,
});
exports.default = i18next_1.default;
